import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useIsWindowResized, useSnappingEnabled, } from '../../Editor/Hooks/useReadOnlyState';
import { SNAPPING_TOGGLED } from '../../Rutab/RutabConstants';
import { translate } from '../../Services/translation';
import PositionFloatingMenu from './PositionFloatingMenu';
const Settings = memo(({ canvas, activeObject }) => {
    const isWindowResized = useIsWindowResized();
    const snappingEnabled = useSnappingEnabled();
    const [showPositionMenu, setShowPositionMenu] = useState(true);
    const [initialMenuPosition, setInitialMenuPosition] = useState({ top: 0, right: 0 });
    const [settingsMenuPosition, setSettingsMenuPosition] = useState({
        top: 0,
        left: 0,
    });
    const dispatch = useDispatch();
    const positionIconRef = useRef(null);
    const updateMenuPositions = useCallback(() => {
        const sideMenu = document.querySelector('.side-menu');
        if (sideMenu) {
            const rect = sideMenu.getBoundingClientRect();
            setSettingsMenuPosition({
                top: rect.top + 5,
                left: rect.width + 5,
            });
            setInitialMenuPosition({
                top: rect.top + 5,
                right: 10,
            });
        }
    }, []);
    useEffect(() => {
        updateMenuPositions();
    }, [isWindowResized, updateMenuPositions]);
    const handlePositionIconClick = useCallback(() => {
        if (activeObject.length === 0)
            return;
        setShowPositionMenu(prev => !prev);
    }, [activeObject.length]);
    const handleSnappingToggle = useCallback(() => {
        dispatch({
            type: SNAPPING_TOGGLED,
            payload: { snappingEnabled: !snappingEnabled },
        });
    }, [dispatch, snappingEnabled]);
    const settingsToolbar = (_jsxs("div", { className: "settings-toolbar", style: {
            top: settingsMenuPosition.top,
            left: settingsMenuPosition.left,
        }, children: [_jsx("div", { className: `settings-icon ${snappingEnabled ? 'active' : ''}`, onClick: handleSnappingToggle, title: translate('decal.settings.snapping.tooltip'), children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "currentColor", className: "bi bi-magnet", viewBox: "0 0 16 16", children: _jsx("path", { d: "M8 1a7 7 0 0 0-7 7v3h4V8a3 3 0 0 1 6 0v3h4V8a7 7 0 0 0-7-7m7 11h-4v3h4zM5 12H1v3h4zM0 8a8 8 0 1 1 16 0v8h-6V8a2 2 0 1 0-4 0v8H0z" }) }) }), _jsx("div", { ref: positionIconRef, className: `settings-icon ${showPositionMenu ? 'active' : ''} ${activeObject.length === 0 ? 'disabled' : ''}`, onClick: handlePositionIconClick, title: translate('decal.settings.position.tooltip'), children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "currentColor", className: "bi bi-crosshair", viewBox: "0 0 16 16", children: _jsx("path", { d: "M8.5.5a.5.5 0 0 0-1 0v.518A7 7 0 0 0 1.018 7.5H.5a.5.5 0 0 0 0 1h.518A7 7 0 0 0 7.5 14.982v.518a.5.5 0 0 0 1 0v-.518A7 7 0 0 0 14.982 8.5h.518a.5.5 0 0 0 0-1h-.518A7 7 0 0 0 8.5 1.018zm-6.48 7A6 6 0 0 1 7.5 2.02v.48a.5.5 0 0 0 1 0v-.48a6 6 0 0 1 5.48 5.48h-.48a.5.5 0 0 0 0 1h.48a6 6 0 0 1-5.48 5.48v-.48a.5.5 0 0 0-1 0v.48A6 6 0 0 1 2.02 8.5h.48a.5.5 0 0 0 0-1zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }) }) })] }));
    return (_jsxs(_Fragment, { children: [settingsToolbar, showPositionMenu && (_jsx(PositionFloatingMenu, { canvas: canvas, activeObject: activeObject, showPositionMenu: showPositionMenu, initialPosition: initialMenuPosition }))] }));
});
export default Settings;
